import startOfWeek from 'date-fns/startOfWeek';
import subWeeks from 'date-fns/subWeeks';

import { ChannelStats } from '../compat/tvpil';

function getStartOfWeekNWeeksAgo(n: number) {
  const currentDate = new Date();
  const startOfCurrentWeek = startOfWeek(currentDate, { weekStartsOn: 1 });

  return subWeeks(startOfCurrentWeek, n);
}

type GetTopXWatchedArgs = {
  watchStats: ChannelStats[];
  watchPeriod: number;
  topX: number;
};

/**
 * Calculates user statistics
 * * @see {@link https://kaltura.atlassian.net/wiki/spaces/KUXDEV/pages/2207777273/Widgets#III.-Get-Top-X-Most-Watch}
 */
export function getTopXWatched({ watchStats, watchPeriod, topX }: GetTopXWatchedArgs) {
  const result: Map<number, number> = new Map();

  const startTime = getStartOfWeekNWeeksAgo(watchPeriod).getTime();

  const channelStatsForPeriod: Record<number, number> = {};

  for (const channelStats of watchStats) {
    channelStatsForPeriod[channelStats.id] = 0;

    for (const weekStats of channelStats.weeks) {
      if (weekStats.weekStartDate >= startTime) {
        channelStatsForPeriod[channelStats.id] += weekStats.count;
      }
    }
  }

  Object.entries(channelStatsForPeriod)
    .sort(([, firstCount], [, secondCount]) => secondCount - firstCount)
    .slice(0, topX)
    .forEach(([channelId, watchCount]) => result.set(Number(channelId), watchCount));

  return result;
}
